import React from 'react';
import {
  Box,
  Flex,
  Stack,
  Text,
  Link,
  ListItem,
  UnorderedList,
} from '@chakra-ui/react';
import { useHistory } from 'react-router-dom';
import { Button, Heading } from '~/components';
import { ROUTER_PATHS } from '~/constants';

export const ContactUs: React.VFC = () => {
  const history = useHistory();
  return (
    <Box px="8" py="4">
      <Heading>Fale Conosco</Heading>
      <Flex
        flexDir="row"
        flexWrap="wrap"
        w="100%"
        py={9}
        gridGap="12"
        style={{
          position: 'relative',
        }}
        fontSize="14px"
      >
        <Flex>
          <Stack gridGap={10}>
            <Text>
              Para problemas técnicos, abertura e acompanhamento de chamados
              envie um e-mail para:
              <br />
              <Link
                href="mailto:positivo.alfa@positivo.com.br"
                target="_blank"
                color="gray.800"
                sx={{ textDecor: 'underline', fontWeight: 'bold' }}
              >
                positivo.alfa@positivo.com.br
              </Link>
            </Text>
            <Text>
              Para dúvidas em relação aos boletos e pagamentos entre em contato
              através do e-mail: <br />
              <Link
                href="mailto:contasareceber@positivo.com.br"
                target="_blank"
                color="gray.800"
                sx={{ textDecor: 'underline', fontWeight: 'bold' }}
              >
                contasareceber@positivo.com.br
              </Link>
            </Text>
            <Text>
              Para dúvidas relacionadas ao seu contrato de locação entre em
              contato através do e-mail:
              <br />
              <Link
                href="mailto:positivoasaservice@positivo.com.br"
                target="_blank"
                color="gray.800"
                sx={{ textDecor: 'underline', fontWeight: 'bold' }}
              >
                positivoasaservice@positivo.com.br
              </Link>
            </Text>
            <Text>
              Ou entre em contato através da Central de Relacionamento Positivo
              através dos seguintes telefones:
              <UnorderedList>
                <ListItem>
                  Capitais e regiões metropolitanas: <strong>4003-4968</strong>
                </ListItem>
                <ListItem>
                  Para demais cidades: <strong>0800-729-0795</strong>
                </ListItem>
              </UnorderedList>
            </Text>

            <Text sx={{ fontStyle: 'italic' }}>
              Atendimento 24x7 exclusivo para clientes Positivo as a Service.
            </Text>
          </Stack>
        </Flex>
      </Flex>
      <Button onClick={() => history.push(ROUTER_PATHS.PORTAL.HOME)}>
        Voltar ao início
      </Button>
    </Box>
  );
};
